import { Youtube, Mail, Lock, Phone, Facebook } from "lucide-react";
import Logo from "@/components/Logo";

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-amber-500/15 bg-[#09090D]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid sm:grid-cols-3 gap-10">
      <div>
        <Logo size={56} />
        <p className="mt-5 text-sm text-zinc-500 leading-relaxed max-w-xs">
          Groupe de reprises rock : une chanteuse, quatre musiciens, et les
          grands classiques des années 70 à aujourd'hui.
        </p>
      </div>
      <div>
        <p className="text-xs font-jbmono uppercase tracking-[0.25em] text-amber-400 mb-4">Contact booking</p>
        <a
          data-testid="footer-email-link"
          href="mailto:fortyone@forty-one.fr"
          className="flex items-center gap-2 text-sm text-zinc-300 hover:text-amber-400 transition-colors duration-300"
        >
          <Mail size={15} />
          fortyone@forty-one.fr
        </a>
        <a
          data-testid="footer-phone-link-1"
          href="tel:+33660714478"
          className="flex items-center gap-2 text-sm text-zinc-300 hover:text-amber-400 transition-colors duration-300 mt-3"
        >
          <Phone size={15} />
          06 60 71 44 78
        </a>
        <a
          data-testid="footer-phone-link-2"
          href="tel:+33660916764"
          className="flex items-center gap-2 text-sm text-zinc-300 hover:text-amber-400 transition-colors duration-300 mt-3"
        >
          <Phone size={15} />
          06 60 91 67 64
        </a>
        <a
          data-testid="footer-youtube-link"
          href="https://www.youtube.com/@41fortyone"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-sm text-zinc-300 hover:text-red-500 transition-colors duration-300 mt-3"
        >
          <Youtube size={15} />
          youtube.com/@41fortyone
        </a>
        <a
          data-testid="footer-facebook-link"
          href="https://www.facebook.com/FortyOne91"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-sm text-zinc-300 hover:text-amber-400 transition-colors duration-300 mt-3"
        >
          <Facebook size={15} />
          @FortyOne91
        </a>
      </div>
      <div>
        <p className="text-xs font-jbmono uppercase tracking-[0.25em] text-amber-400 mb-4">Espace membre</p>
        <a
          data-testid="footer-admin-link"
          href="/admin"
          className="flex items-center gap-2 text-sm text-zinc-300 hover:text-amber-400 transition-colors duration-300"
        >
          <Lock size={14} />
          Espace admin
        </a>
      </div>
    </div>
    <div className="border-t border-zinc-900">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-xs text-zinc-600">© {new Date().getFullYear()} Forty One — Tous droits réservés</p>
        <p className="text-[11px] font-jbmono uppercase tracking-widest text-zinc-700">Rock covers • 70s → aujourd'hui</p>
      </div>
    </div>
  </footer>
);

export default Footer;
